import { RWebShare } from 'react-web-share';
import { PopupModal } from 'components/PopupModal';
import { ButtonBrand } from 'components/ButtonBrand';
import { useAppSelector } from 'helpers/hooks';
import { useShareUrl } from 'hooks/useShareUrl';
import { getSetsData } from 'selectors/sets';
import { getUserState } from 'selectors/user';
import colors from 'config/theme/colors';
import { sanitizeHtml } from 'helpers/utils';

export const MaximizeImpact = () => {
  const { userState, setsData } = useAppSelector(state => ({
    userState: getUserState(state),
    setsData: getSetsData(state),
  }));
  const { handleShare, urlWithRefCode, isPopupOpen } = useShareUrl({
    userRefCode: userState.data?.ref_code,
    shareCurrentUrl: true,
  });

  const ShareButton = () => {
    const content = (
      <ButtonBrand
        onClick={handleShare}
        $backgroundColor={setsData?.set_misc?.issue_misc?.cta_color || colors.oathBlue}
        $gradientColor={setsData?.set_misc?.tertiary_color || colors.oathBlue}
      >
        {setsData?.set_misc?.share_alt || 'Share with friends'}
      </ButtonBrand>
    );
    return (
      <>
        <div className="share-container">{content}</div>
        <div className="share-container show-on-mobile">
          <RWebShare
            data={{
              url: urlWithRefCode,
              title: 'Refer your friends',
            }}
            onClick={() => console.log('shared successfully!')}
          >
            {content}
          </RWebShare>
        </div>
      </>
    );
  };

  return (
    <>
      <PopupModal autoClose={true} isSelected={isPopupOpen} title="Copied to Clipboard" />
      {setsData?.set_misc?.has_share && (
        <div className="maximize-impact-container">
          <div className="maximize-column">
            <span className="h2-dtm">{setsData?.set_misc?.share_title}</span>
            <span
              className="description color-inkBlue"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(setsData?.set_misc?.share_description),
              }}
            />
            <ShareButton />
          </div>
          <div className="orbs-texts-container custom-disclaimer">
            <div
              className="body-small-text color-black shadow-7"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(setsData?.set_misc?.share_disclaimer),
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
